import React, {memo} from "react";
import {TextField} from "@material-ui/core";
import "./index.scss";


const TextArea = ({name, className, label, value, onChange, ...fieldProps}) => (
    <TextField
        id={name}
        name={name}
        className={`textarea${className ? ' ' + className : ''}`}
        label={label}
        value={value}
        onChange={onChange}
        variant="outlined"
        size="small"
        multiline
        fullWidth
        {...fieldProps} 
    />
);

export default memo(TextArea);